import { Button, Text, H2, Input, Label, Paragraph, Separator, TextArea, XStack, YStack, XPModal, Image, Theme } from "@my/ui"
import { useAuthedRequestFn } from "@my/util"
import { APP_ENV } from '@my/config'
import { Send } from "@tamagui/lucide-icons-2"
import { useState } from "react"
import { Controller, useForm } from 'react-hook-form'
import images from "../../assets/images"

export const ShareFeedbackScreen: React.FC<{open: boolean; setOpen: (x: boolean) => any}> = ({open, setOpen}) => {
  const authedRequestFn = useAuthedRequestFn();
  //const [customModalOpen, setCustomModalOpen] = useState<boolean>(false);
  const [status, setStatus] = useState('idle'); // 'idle', 'sending', 'complete'
  const [subject, setSubject] = useState('');
  const [feedback, setFeedback] = useState('');
  const { control, handleSubmit, formState: { errors } } = useForm<{subject: string; feedback: string; }>({
    defaultValues: {
      subject: '',
      feedback: '',
    },
  });
  const genHandleChange = (fn) => (event) => {
    fn(event.target.value);
  };
  const sendFeedback = async ({subject, feedback}) => {
    const payload = {
      subject,
      feedback,
      ts: Date.now(),
      env: {
        env: APP_ENV.TZA_ENV,
        url: window.location.href
      }
    };
    setStatus('sending');
    try {
      await authedRequestFn('/feedback', { method: 'POST', body: payload });
      setStatus('complete');

      // After 5 seconds, revert to idle
      setTimeout(() => {
        setStatus('idle');
      }, 5000);
    } catch (e) {

    }


  }

  const body = <YStack gap={15}
    style={{
      backgroundColor: 'white',
      color: 'black'
    }}
  >
    <H2 color='black'>Share Questions & Suggestions</H2>
    <Separator  color='black' />
    <Paragraph color='black'>Please share with us any Questions or Suggestions you might have for improving your Parity experience. Thanks!</Paragraph>
    <YStack gap={15}>
      <XStack gap={10} style={{alignItems: 'center'}}>
        <Label htmlFor='feedback-subject' color='black'>Subject:</Label>
        <Controller
          name="subject"
          control={control}
          rules={{ required: 'Subject is required' }}
          render={({ field }) => (
            <>
              <Input
                {...field} // Spreads onChange, onBlur, value, and name
                placeholder=""
                //size="$4"
                style={{flexGrow: 1,  color: 'black', backgroundColor: 'white'}}
              />
              {errors.subject && <Text color="red">{errors.subject.message}</Text>}
            </>
          )}
        />
      </XStack>
      <Controller
        name="feedback"
        control={control}
        rules={{ required: 'Feedback is required' }}
        render={({ field }) => (
          <>
            <TextArea
              {...field} // Spreads onChange, onBlur, value, and name
              placeholder="Enter your questions or suggestions here..."
              placeholderTextColor="black"
              style={{color: 'black', backgroundColor: 'white'}}
              size="$4"
              rows={4} // Example Tamagui TextArea prop
            />
            {errors.feedback && <Text color="red">{errors.feedback.message}</Text>}
          </>
        )}
      />
      <XStack style={{justifyContent: 'flex-end'}} gap={10}>
        {status === 'sending' && <Paragraph>Sending...</Paragraph>}
        {status === 'complete' && <Paragraph>Thanks!</Paragraph>}
        <Button
          //disabled={!subject && !feedback} 
          {...(subject && feedback ? {icon: <Send color={'white'} />, style: { color: 'white', backgroundColor: 'rgb(133, 193, 157)'}} : {icon: <Send /> , style: { color: 'black', backgroundColor: 'rgb(222, 222, 222)'}})}
          onPress={handleSubmit(sendFeedback)}
        >
          Share
        </Button>
      </XStack>
    </YStack>
  </YStack>;

  const modal = <XPModal
      open={open} 
      webContentProps={{width: '85%', maxWidth: 800, minHeight: 400, overflow: 'hidden', 
        style: {
          backgroundColor: 'white',
          color: 'black'
        },
        backGroundColor: 'white'
      }}
      nativeModalType={'library'}
      otherProps={{style: {
        backgroundColor: 'white',
        width: '85%', maxWidth: 500, maxHeight: '70%', overflow: 'hidden', alignSelf: 'center',
        padding: 18, borderRadius: 9, marginTop: '30%'
      }}}
      overlayProps={{backgroundColor: 'rgba(255,255,255,0.6)' }}
      onBackgroundPress={() => setOpen(false)}
    >
      
      <Button onPress={() => setOpen(false)} style={{ position: 'absolute', right: 5, top: 5, zIndex: 5, backgroundColor: 'rgb(255, 255, 255)' }}>
        <Image src={images.cross} style={{ height: 17, width: 17 }} />
      </Button>
      {body}
    </XPModal>

  return modal;
}